import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { ElementType } from '@fiverr-private/bianka_js';
import { Container } from '@fiverr-private/layout_components';
import { translate } from '../../../shared/helpers';
import { Heading } from '../ui/Heading';
import CategoryPreviewCard from '../CategoryPreviewCard';
import CategoryPreviewsLayout from '../CategoryPreviewsLayout';
import { sendBiankaImpression, sendBiankaClick } from '../../../shared/biEvents';
import { EVENT_NAMES } from '../../../shared/biEvents/eventNames';
import { sendMixpanelEvent } from '../utils/mixpanel';
import { MIXPANEL_EVENTS } from '../utils/eventNames';
import { enrichUrlWithParams } from '../../../shared/urlEnrichment';
import { CATEGORY_PREVIEWS } from './constants';
import { heading, sectionContainer, carouselWithPadding } from './styles.ve.css';

const PopularServices: React.FC = () => {
  const observableRef = useRef<HTMLDivElement>(null);

  useEnteredView(observableRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.CATALOG_SERVICES_IS_SHOWN,
        componentName: 'popular_services_catalog',
        componentText: translate('v17.popular_services.title'),
        isV16: true,
      });
    },
  });

  const handleCategoryClick = (category: (typeof CATEGORY_PREVIEWS)[0], index: number) => {
    const categoryTitle = translate(`v17.popular_services.categories.${category.titleKey}`);

    sendBiankaClick({
      eventName: EVENT_NAMES.BIANKA.CLICKED_ON_CATALOG_SERVICE_BUTTON,
      elementName: 'catalog_service_button',
      elementType: ElementType.CARD,
      elementText: categoryTitle,
      position: index + 1,
      isV16: true,
    });

    sendMixpanelEvent({
      eventName: MIXPANEL_EVENTS.CLICKED_CATALOG_SERVICE_BUTTON,
      clickedElement: categoryTitle,
      position: index + 1,
    });
  };

  return (
    <Container className={sectionContainer}>
      <CategoryPreviewsLayout
        carouselClassName={carouselWithPadding}
        header={
          <Heading
            as="h2"
            ref={observableRef}
            className={heading}
            paddingTop={{
              default: '8',
              sm: '16',
              md: '20',
              xl: '24',
            }}
          >
            {translate('v17.popular_services.title')}
          </Heading>
        }
      >
        {CATEGORY_PREVIEWS.map((category, index) => (
          <CategoryPreviewCard
            key={index}
            videoSrc={category.videoSrc}
            posterSrc={category.posterSrc}
            overlayColor={category.overlayColor}
            title={translate(`v17.popular_services.categories.${category.titleKey}`)}
            href={enrichUrlWithParams(category.href, 'hplo_catalog')}
            onClick={() => handleCategoryClick(category, index)}
          />
        ))}
      </CategoryPreviewsLayout>
    </Container>
  );
};

export default PopularServices;
